/**
 * @generated SignedSource<<23fd73b98af60a2635b57189b63206a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type commentsCell_softwareCodePage$data = {
  readonly commentCount: number | null | undefined;
  readonly " $fragmentType": "commentsCell_softwareCodePage";
};
export type commentsCell_softwareCodePage$key = {
  readonly " $data"?: commentsCell_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"commentsCell_softwareCodePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "commentsCell_softwareCodePage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "commentCount"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "558cb416b6d71ec970c12dfec11c632c";

export default node;
